import { useMemo } from "react";
import Calendar from "./Calendar";
import { useData } from "@/v2/contexts/DataProvider";
import { buildDailySums } from "@/v2/lib/daySums";

/** Thin wrapper that connects the Calendar component to v2's DataProvider */
export default function CalendarPage() {
	const { entries, exportedEntries } = useData();
	const dailySums = useMemo(
		() => buildDailySums(entries, exportedEntries),
		[entries, exportedEntries],
	);
	return <Calendar dailySums={dailySums} />;
}
